import { render, staticRenderFns } from "./SaveViewForm.vue?vue&type=template&id=60a1851a&"
import script from "./SaveViewForm.vue?vue&type=script&lang=js&"
export * from "./SaveViewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports